export const COOKIES_POLICY_KEY = 'margex_cookies_policy'
export const SECOND_IN_MS = 1000
export const MINUTE = 60 * SECOND_IN_MS
export const COPYTRADING_BANNER = 'margex_copytrading'
